import type { Theme } from '@mui/material'
import { DesktopTimePicker } from '@mui/x-date-pickers'
import { type ReactElement } from 'react'
import { Controller, type FieldValues } from 'react-hook-form'
import type { KNFormTimeProps } from './types'

const KNFormTimeNext = <T extends FieldValues>({
  name,
  control,
  rules,
  label,
  disabled,
  size,
  sx,
  precise,
}: KNFormTimeProps<T>): ReactElement => {
  return (
    <Controller
      name={name}
      control={control}
      rules={{
        ...rules,
        validate: {
          ...rules?.validate,
        },
      }}
      render={({ field: { onChange, value }, fieldState: { invalid, error }, formState }): ReactElement => (
        <DesktopTimePicker
          value={value ?? null}
          onChange={(newValue) => {
            onChange(newValue)
          }}
          label={label}
          closeOnSelect
          thresholdToRenderTimeInASingleColumn={48}
          timeSteps={{ hours: 1, minutes: precise ? 1 : 30 }}
          slotProps={{
            textField: {
              fullWidth: true,
              error: invalid,
              helperText: error?.message,
              size,
              sx,
            },
            digitalClockItem: {
              sx: (theme: Theme) => ({
                borderRadius: theme.borders.borderRadius['md'],
                '&.Mui-selected, &.Mui-selected:hover': {
                  backgroundColor: theme.palette.secondary.main,
                },
              }),
            },
            digitalClockSectionItem: {
              sx: (theme: Theme) => ({
                borderRadius: theme.borders.borderRadius['md'],
                '&.Mui-selected, &.Mui-selected:hover': {
                  backgroundColor: theme.palette.secondary.main,
                },
              }),
            },
          }}
          disabled={formState.isSubmitting ?? disabled}
        />
      )}
    />
  )
}

export default KNFormTimeNext
